import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStateName } from "../../util/useStateName";
export const TextStateChip = ({ state, variant, size, sx, }) => {
    const { t } = useTranslation("sprava-textu");
    //"MISSING_TEXT" | "MISSING_TRANSLATION" | "NEED_REVIEW" | "TRANSLATED"
    const getStateName = useStateName();
    const StateConfig = [
        {
            state: "MISSING_TEXT",
            label: getStateName("MISSING_TEXT"),
            color: "error",
        },
        {
            state: "MISSING_TRANSLATION",
            label: getStateName("MISSING_TRANSLATION"),
            color: "warning",
        },
        {
            state: "NEED_REVIEW",
            label: getStateName("NEED_REVIEW"),
            color: "info",
        },
        {
            state: "TRANSLATED",
            label: getStateName("TRANSLATED"),
            color: "success",
        },
    ];
    const getChipConfig = (state) => {
        const config = StateConfig.find((item) => item.state === state);
        if (!config) {
            return {
                label: "sprava-textu.textsTable.unknownState",
                color: "default",
            };
        }
        return {
            label: config.label,
            color: config.color,
        };
    };
    const { label, color } = getChipConfig(state);
    return (_jsx(Chip, { label: label, variant: variant ?? "filled", size: size ?? "medium", color: color, sx: sx }));
};
